import { trackEvent } from 'integrations/metrics';
import { EventNames } from 'integrations/metrics/events';
import { snakeCase } from 'lodash';

type PostBookingSurveyEvents = () => {
  trackOriginSurvey: () => void;
  trackGoBack: (origin: string) => void;
  trackClose: () => void;
  trackSubmit: (origin: string, detail: string) => void;
};

export const usePostBookingSurveyEvents: PostBookingSurveyEvents = () => {
  function trackOriginSurvey() {
    trackEvent(EventNames.ORIGIN_SURVEY);
  }

  function trackGoBack(origin: string) {
    trackEvent(EventNames.CLIENT_GOES_BACK_IN_ORIGIN_SURVEY, {
      client_origin: snakeCase(origin),
    });
  }

  function trackClose() {
    trackEvent(EventNames.CLIENT_CLOSES_ORIGIN_SURVEY);
  }

  function trackSubmit(origin: string, detail: string) {
    trackEvent(EventNames.CLIENT_SUBMITS_ORIGIN_SURVEY, {
      client_origin: snakeCase(origin),
      client_origin_detail: snakeCase(detail),
    });
  }

  return { trackOriginSurvey, trackGoBack, trackClose, trackSubmit };
};
